import { render, staticRenderFns } from "./result-detail-quiz.vue?vue&type=template&id=5edbefae&scoped=true&"
import script from "./result-detail-quiz.vue?vue&type=script&lang=js&"
export * from "./result-detail-quiz.vue?vue&type=script&lang=js&"
import style0 from "./result-detail-quiz.vue?vue&type=style&index=0&lang=css&"
import style1 from "./result-detail-quiz.vue?vue&type=style&index=1&id=5edbefae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbefae",
  null
  
)

export default component.exports